export default __webpack_public_path__ + "75df8aea1548d008713a018f61987147.png";